import produce from 'immer';
import { AnyAction } from 'redux';
import {
  FETCH_WALLET_BALANCE_ERROR,
  FETCH_WALLET_BALANCE_LOADING,
  FETCH_WALLET_BALANCE_SUCCESS,
  SET_WALLET_CURRENCY
} from '../ActionTypes';
import { IWalletBalance } from 'interfaces';

const currency = localStorage.getItem('currency') || 'FTN';

type InitialStateType = {
  loading: boolean;
  loaded: boolean;
  error: string;
  data: IWalletBalance;
};

export const INIT_STATE: InitialStateType = {
  loading: false,
  loaded: false,
  error: '',
  data: {
    currency,
    balance: '0.0000',
    formatted_balance: '0.00 USDT'
  }
};

export const WalletBalanceReducer = (
  state = INIT_STATE,
  action: AnyAction
): InitialStateType =>
  produce(state, draft => {
    switch (action.type) {
      case FETCH_WALLET_BALANCE_LOADING:
        draft.error = '';
        draft.loading = true;
        draft.loaded = false;
        break;
      case FETCH_WALLET_BALANCE_SUCCESS:
        draft.loading = false;
        draft.loaded = true;
        draft.data = action.payload;
        break;
      case FETCH_WALLET_BALANCE_ERROR:
        draft.loading = false;
        draft.loaded = false;
        draft.error = action.payload;
        break;
      case SET_WALLET_CURRENCY:
        localStorage.setItem('currency', action.payload);
        draft.data.currency = action.payload;
        break;
    }
  });
